var _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 95,
    viewBox: "0 0 17 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4694 2.74234C10.4694 1.59477 9.5391 0.66449 8.39153 0.66449C7.24397 0.66449 6.31368 1.59477 6.31368 2.74234V3.82441C6.31368 5.56789 4.90032 6.98126 3.15684 6.98126L2.07785 6.98126C0.930284 6.98126 0 7.91154 0 9.0591C0 10.2067 0.930283 11.137 2.07785 11.137H3.15684C4.90032 11.137 6.31368 12.5503 6.31368 14.2938V15.3758C6.31368 16.5234 7.24397 17.4536 8.39153 17.4536C9.5391 17.4536 10.4694 16.5234 10.4694 15.3758V14.2953C10.4694 12.551 11.8834 11.137 13.6277 11.137H14.7113C15.8589 11.137 16.7892 10.2067 16.7892 9.0591C16.7892 7.91154 15.8589 6.98126 14.7113 6.98126L13.6278 6.98126C11.8834 6.98126 10.4694 5.5672 10.4694 3.82287V2.74234Z",
    fill: "#F69A4D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.89453,
    y1: 22.4536,
    x2: 8.89453,
    y2: 94.6949,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeDasharray: "3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/listIcon.49184d28982c44e62258f32a6875b3bb.svg";
export { ForwardRef as ReactComponent };